import React from "react";
import styled from "styled-components";
import Select from "react-select";

import Logo from "../../Resources/Images/logo.png";
import LogoEsg from "../../Resources/Images/logo_esg.png";
import LogoUsdt from "../../Resources/Images/coin_usdt.png";
import customStyles from "../../Styles/SelectStyle";
import { EthereumIcon } from "./Icons";

const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const OptionSpan = styled.span`
  margin-left: 5px;
`;

const SelectWrapper = styled.div`
  padding: 5px 10px;
  width: 100%;
`;

const Container = ({ disabled = false, selected, style, type = "all", placeholder = "Choose asset" }) => {
  const handleChange = ({ value }) => {
    selected.setState(value);
  };

  return (
    <SelectWrapper style={style}>
      {type === "all" && (
        <Select
          isDisabled={disabled}
          onChange={handleChange}
          isClearable={false}
          isSearchable={false}
          styles={customStyles}
          placeholder={placeholder}
          options={options}
        />
      )}
      {type === "lockup" && (
        <Select
          isDisabled={disabled}
          onChange={handleChange}
          isClearable={false}
          isSearchable={false}
          styles={customStyles}
          placeholder={placeholder}
          options={lockupOption}
        />
      )}
      {type === "available" && (
        <Select
          isDisabled={disabled}
          onChange={handleChange}
          isClearable={false}
          isSearchable={false}
          styles={customStyles}
          placeholder={placeholder}
          options={availableOptions}
        />
      )}
      {type === "erc" && (
        <Select
          isDisabled={disabled}
          onChange={handleChange}
          isClearable={false}
          isSearchable={false}
          styles={customStyles}
          placeholder={placeholder}
          options={ercOptions}
        />
      )}
      {type === "eth" && (
        <Select
          isDisabled={disabled}
          onChange={handleChange}
          isClearable={false}
          isSearchable={false}
          styles={customStyles}
          placeholder={placeholder}
          options={ethOptions}
        />
      )}
    </SelectWrapper>
  );
};

export default Container;

const options = [
  {
    value: "lcms",
    label: (
      <OptionWrapper>
        <img src={Logo} style={{ width: 16, height: 16 }} />
        <OptionSpan>LCMS (LCM Science)</OptionSpan>
      </OptionWrapper>
    ),
  },
  {
    value: "esg",
    label: (
      <OptionWrapper>
        <img src={LogoEsg} style={{ width: 16, height: 16 }} />
        <OptionSpan>ESG (Energy Solution Global)</OptionSpan>
      </OptionWrapper>
    ),
  },
  {
    value: "eth",
    label: (
      <OptionWrapper>
        <EthereumIcon size={18} />
        <OptionSpan>ETH (Ethereum)</OptionSpan>
      </OptionWrapper>
    ),
  },
  {
    value: "usdt",
    label: (
      <OptionWrapper>
        <img src={LogoUsdt} style={{ width: 16, height: 16 }} />
        <OptionSpan>USDT (Tether USD)</OptionSpan>
      </OptionWrapper>
    ),
  },
];

const availableOptions = [
  {
    value: "lcms",
    label: (
      <OptionWrapper>
        <img src={Logo} style={{ width: 16, height: 16 }} />
        <OptionSpan>LCMS (LCM Science)</OptionSpan>
      </OptionWrapper>
    ),
  },
  {
    value: "esg",
    label: (
      <OptionWrapper>
        <img src={LogoEsg} style={{ width: 16, height: 16 }} />
        <OptionSpan>ESG (Energy Solution Global)</OptionSpan>
      </OptionWrapper>
    ),
  },
  {
    value: "eth",
    label: (
      <OptionWrapper>
        <EthereumIcon size={18} />
        <OptionSpan>ETH (Ethereum)</OptionSpan>
      </OptionWrapper>
    ),
  },
  {
    value: "usdt",
    label: (
      <OptionWrapper>
        <img src={LogoUsdt} style={{ width: 16, height: 16 }} />
        <OptionSpan>USDT (Tether USD)</OptionSpan>
      </OptionWrapper>
    ),
  },
];

const ethOptions = [
  {
    value: "eth",
    label: (
      <OptionWrapper>
        <EthereumIcon size={18} />
        <OptionSpan>ETH (Ethereum)</OptionSpan>
      </OptionWrapper>
    ),
  },
];

const ercOptions = [
  {
    value: "lcms",
    label: (
      <OptionWrapper>
        <img src={Logo} style={{ width: 16, height: 16 }} />
        <OptionSpan>LCMS (LCM Science)</OptionSpan>
      </OptionWrapper>
    ),
  },
  {
    value: "esg",
    label: (
      <OptionWrapper>
        <img src={LogoEsg} style={{ width: 16, height: 16 }} />
        <OptionSpan>ESG (Energy Solution Global)</OptionSpan>
      </OptionWrapper>
    ),
  },
  {
    value: "usdt",
    label: (
      <OptionWrapper>
        <img src={LogoUsdt} style={{ width: 16, height: 16 }} />
        <OptionSpan>USDT (Tether USD)</OptionSpan>
      </OptionWrapper>
    ),
  },
];
const lockupOption = [
  {
    value: "lcms",
    label: (
      <OptionWrapper>
        <img src={Logo} style={{ width: 16, height: 16 }} />
        <OptionSpan>LCMS (LCM Science)</OptionSpan>
      </OptionWrapper>
    ),
  },
  {
    value: "esg",
    label: (
      <OptionWrapper>
        <img src={LogoEsg} style={{ width: 16, height: 16 }} />
        <OptionSpan>ESG (Energy Solution Global)</OptionSpan>
      </OptionWrapper>
    ),
  },
];
